import { render, staticRenderFns } from "./articleGsc.vue?vue&type=template&id=0e56a0fa&scoped=true&"
import script from "./articleGsc.vue?vue&type=script&lang=js&"
export * from "./articleGsc.vue?vue&type=script&lang=js&"
import style0 from "./articleGsc.vue?vue&type=style&index=0&id=0e56a0fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56a0fa",
  null
  
)

export default component.exports